export default __webpack_public_path__ + "static/media/u-said-it-v13-1167.4850ef5b.mp3";